import {NgModule} from '@angular/core';
import {WalkthroughQrCodesComponent} from './walkthrough-qr-codes/walkthrough-qr-codes.component';
import {AssetPipeModule} from '../../sdk/pipe/assetPipeModule';
import {NgOptimizedImage} from '@angular/common';
import {WalkthroughIntroductionComponent} from './walkthrough-introduction/walkthrough-introduction.component';
import {WalkthroughCompleteComponent} from './walkthrough-complete/walkthrough-complete.component';
import {WalkthroughQuickpayComponent} from './walkthrough-quickpay/walkthrough-quickpay.component';
import {WalkthroughBulkUploadComponent} from './walkthrough-bulk-upload/walkthrough-bulk-upload.component';
import {WalkthroughCreateInvoiceComponent} from './walkthrough-create-invoice/walkthrough-create-invoice.component';

@NgModule({
    declarations: [
        WalkthroughQrCodesComponent,
        WalkthroughIntroductionComponent,
        WalkthroughQuickpayComponent,
        WalkthroughBulkUploadComponent,
        WalkthroughCompleteComponent,
        WalkthroughCreateInvoiceComponent
    ],
    exports: [
        WalkthroughQrCodesComponent,
        WalkthroughIntroductionComponent,
        WalkthroughCompleteComponent,
        WalkthroughBulkUploadComponent,
        WalkthroughCreateInvoiceComponent,
        WalkthroughQuickpayComponent
    ],
    imports: [AssetPipeModule, NgOptimizedImage]
})
export class WalkthroughModule
{
}